import { useSSFBehaviors, useURLParameters } from 'hooks';
import { FC, useContext, useMemo } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import {
  CalloutListData,
  calloutListQueryConfig,
} from 'components/ShiftModal/src/views/AuditTrailView/AuditTrailView.constants';
import { ShiftModalOrderDetailsCalloutListQuery, CalloutList } from 'types/graphql';
import { calculateEstimatedTimeRemaining } from 'components/ShiftModal/src/views/DetailView/GeneralTab/CallOut';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export const AuditTrailDataContext = createGQLDataContext({} as CalloutListData);

export const AuditTrailDataProvider: FC = ({ children }) => {
  const [{ calloutListId }] = useURLParameters<{ calloutListId: string }>();

  const [values, useQueryOptions] = useSSFBehaviors<ShiftModalOrderDetailsCalloutListQuery>(
    calloutListQueryConfig(calloutListId),
  );

  const { timeZone } = getCurrentlySelectedLocation();

  const value = useMemo(() => {
    const nodeData = useQueryOptions?.data?.node as CalloutList;

    return {
      estimatedTimeRemaining: nodeData?.estimatedCompletedAt
        ? calculateEstimatedTimeRemaining(nodeData.estimatedCompletedAt, timeZone)
        : { mins: 0, hours: 0, days: 0 },
      values,
      ...useQueryOptions,
    };
  }, [timeZone, useQueryOptions, values]);

  return <AuditTrailDataContext.Provider value={value}>{children}</AuditTrailDataContext.Provider>;
};

export const useAuditTrailDataContext = (): CalloutListData => useContext(AuditTrailDataContext);
